module.exports = __webpack_public_path__ + "img/fatoorah.9ad19d51.png";